import { combineReducers } from "redux";
import { authReducer } from "./authReducer";
import leadReducer from "./leadsReducer";
import snackReducer from "./snackReducer";
import loaderReducer from "./loaderReducer";

const rootReducer = combineReducers({
    Auth: authReducer,
    Leads: leadReducer,
    Snack: snackReducer,
    Loader: loaderReducer
})

export default rootReducer